module.exports = __webpack_public_path__ + "static/media/archie.826c94eb.jpg";